import { ReactNode, useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "./authContext/AuthContext";
import { useCompanyAccessStore } from "@/common/states/store/CompanyAccess";
import Loading from "../ui/loading/Loading";
import { useUser } from "@/common/services/users.api";
import { buildLoginRedirectPath } from "../../helpers/auth-session.helpers";

type Props = {
  children: ReactNode;
};

function PrivateRouteWithCompanyValidation({ children }: Props) {
  const { auth, authReady } = useContext(AuthContext);
  const { companyAccess } = useCompanyAccessStore()
  const user = useUser()
  const location = useLocation();
  const isLoadingAccess = !authReady && companyAccess === undefined;
  const invalidAccess = !user && (companyAccess === undefined || companyAccess === null)

  if(isLoadingAccess) {
    return <Loading />
  }

  if (!auth) {
    return (
      <Navigate
        to={buildLoginRedirectPath(
          `${location.pathname}${location.search}${location.hash}`
        )}
        replace
      />
    );
  }

  if (!user) {
    return (
      <Navigate
        to={buildLoginRedirectPath(
          `${location.pathname}${location.search}${location.hash}`
        )}
        replace
      />
    );
  }

  if (invalidAccess) {
    return <Navigate to="/login?error=Acesso inválido" />;
  }
  
  return <>{children}</>;
}

export default PrivateRouteWithCompanyValidation;
